/**
 * @file AWS Secrets Manager Helper
 * @description This module provides a helper function to retrieve secret values from AWS Secrets Manager.
 * @author SONAL JAIN
 * @requires aws-sdk
 * @created 20/08/2024
 */

const AWS = require('aws-sdk');

/**
 * Retrieves a secret value from AWS Secrets Manager.
 * @param {string} secretName - The name of the secret.
 * @returns {Promise<string>} - A promise that resolves to the secret value.
 */
export const getSecretManager = async (access_key, secret_key, session_token, dashboard) => {
  var credentials = {
    accessKeyId: access_key,
    secretAccessKey: secret_key,
    sessionToken: session_token
  };

  AWS.config.update({ credentials: credentials, region: process.env.REACT_APP_REGION, signatureVersion: "v4" });
  var secretName = process.env.REACT_APP_SECRET_NAME
  // Create an instance of the AWS Secrets Manager client
  const secretsManager = new AWS.SecretsManager();

  // Retrieve the secret value
  const secretValue = await secretsManager.getSecretValue({
    SecretId: secretName
  }).promise();

  if (secretValue.SecretString) {
    const secretObject = JSON.parse(secretValue.SecretString);

    // Fetch the specific values from the secret
    const s3AccessKey = secretObject[process.env.REACT_APP_SECRET_MANAGER_ACCESS_KEY];
    const s3SecretKey = secretObject[process.env.REACT_APP_SECRET_MANAGER_SECRET_KEY];
    localStorage.setItem('access_key', s3AccessKey)
    localStorage.setItem('secret_key', s3SecretKey)
    
    return {
      s3AccessKey,
      s3SecretKey
    };
  } else {
    throw new Error(`Secret ${secretName} is binary and cannot be parsed as a string.`);
  }
};

// module.exports = { getSecretManager };
